const Websocket = {
  url: 'wss://us6dackejc.execute-api.eu-central-1.amazonaws.com/prod',
  port: 80
}

export default Websocket;